export const ANALYTICS_PAGE_TITLE_KEY = Symbol('analytics-page-title')

export function createAnalyticsPageTitleContext() {
  let nextId = 0
  const entries = []

  const register = (title) => {
    const id = ++nextId
    entries.push({ id, title })
    return id
  }

  const update = (id, title) => {
    const entry = entries.find((item) => item.id === id)
    if (entry) entry.title = title
  }

  const unregister = (id) => {
    const index = entries.findIndex((item) => item.id === id)
    if (index >= 0) entries.splice(index, 1)
  }

  // 不使用 Array.prototype.at()：iOS 15.0–15.3 未實作，專案相容目標為 iOS >= 15
  const current = () => entries[entries.length - 1]?.title || ''

  return {
    current,
    register,
    unregister,
    update,
  }
}

export function getAnalyticsPageTitleContext(nuxtApp) {
  if (!nuxtApp._analyticsPageTitleContext) {
    nuxtApp._analyticsPageTitleContext = createAnalyticsPageTitleContext()
  }
  return nuxtApp._analyticsPageTitleContext
}

export function resolveAnalyticsPageTitle(payload = {}, currentPageTitle = '', documentTitle = '') {
  return payload.page_title || currentPageTitle || documentTitle
}
